  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">SDDR CERRADO</li>
            <li class="breadcrumb-item">Aportaciones de DI/FS</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda Aportaciones de DI/FS</h2>
            <div *ngIf="canAccessNuevoDis() || canAccessCargaMasivaDis()" style="display: flex; align-items: center;">
                <!-- <button  type="button" class="btn btn-primary" data-toggle="modal"  style="margin-left:1.5em;"
              (click)="openModalContributions(true, true)">Carga aportaciones ficheros multiples</button> -->
              <button  type="button" class="btn btn-primary" data-toggle="modal"
              matTooltip="Solo se permite un DI/FS por archivo cargado, con un máximo de hasta 20 documentos."
              matToolTipPosition="above"
              (click)="openModalContributions(true)">Carga aportaciones DI/FS</button>
            <button *ngIf="canAccessNuevoDis()" type="button" class="btn btn-primary" data-toggle="modal"
             matTooltip="Debe cumplimentar los datos de este formulario y subir 1 documento (DI/FS)"
             matToolTipPosition="above" style="margin-left:1.5em;"
              (click)="openModalContributions(false)"><span class="icon-add"></span>Nueva aportación DI/FS</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
    <!-- Formulario de búsqueda -->
  <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
  <!-- Formulario de búsqueda -->
  <form *ngIf="mostrarFiltros"  class="container form-search py-3" [formGroup]="searchForm">
      <div class="row form">
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('AD-ADHERIDO')" style="flex: 1 1 300px; max-width: 400px;">
          <ng-container>
            <label for="adherido">Adherido </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <mat-select formControlName="adherido" id="adherido" placeholder="-- Adherido --" multiple>
                  <mat-option *ngFor="let adherido of adheridoArray" [value]="adherido.id">
                    {{ adherido.razonSocial }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div class="col-sm flex-grow-2" style="flex: 1 1 300px; max-width: 400px;" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')">
          <label for="adherido">Razón Social Adherido </label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination [endPointFilter]="adheridoEndpoint" [multiple]=true [updateList]="updateList"
              [placeHolder]="'--Razón Social Adherido--'" [formControlNameSelect]="getFormControl('adherido')"
              [descripcion]="getAdheridoDescription" [objQueryName]="getAdheridoObjectQuery" [defaultParameters]="defaultAdheridosParameters"
              [enableTooltip]="true" [tooltip]="getAdheridoDescription">
            </lib-ge-select-pagination>
          </div>
        </div>

        <div class="col-sm flex-grow-1" *ngIf="canViewResource('AD-ADHERIDO')">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 150px; max-width: 200px;">
          <label for="idposeedor">ID. Adherido </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idAdherido" id="idAdherido" placeholder="ID. Adherido" type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 250px; max-width: 300px;">
          <label for="codigo_documento">Documento adherido (NIE, NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento" id="codigo_documento"
                placeholder="Documento (NIE, NIF)" type="text" maxlength="15">
              <mat-error *ngIf="controlHasError( 'codigo_documento', 'maxlength')">Máximo 15 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 200px; max-width: 300px;">
          <label for="estado">Estado adherido</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estadoAdherido" id="estadoAdherido" placeholder="-- Estado adherido--" multiple>
                <mat-option *ngFor="let des of estadoArrayAdherido" [value]="des.id">
                  {{ des.descripcion_corta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estadoAdherido')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estadoAdherido')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
                <div style="flex: 1 1 300px; max-width: 400px;" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')">
          <label for="gestor">Razón Social Gestor - NIMA - Centro </label>
          <div class="custom-mat-field">
             <lib-ge-select-pagination [endPointFilter]="listaGestores" [multiple]=true [updateList]="updateList"
              [placeHolder]="'-- Gestores --'" [formControlNameSelect]="getFormControl('gestor')"
              [descripcion]="getGestorDescription" [objQueryName]="getGestorObjectQuery" [customClass]="rightHolder('gestor')"
              [defaultParameters]="defaultGestoresParameters" [enableTooltip]="true" [tooltip]="getGestorDescription">
            </lib-ge-select-pagination>
          </div>
        </div>
                <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')">
          <label for="nima_gestor">NIMA del gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nima_gestor" id="nima_gestor" placeholder="NIMA del gestor " type="text" maxlength="10" (input)="onInput('nima_gestor', $event)">
              <mat-error *ngIf="controlHasError('nima_gestor', 'pattern')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError( 'nima_gestor', 'maxlength')">Máximo 10 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 200px; max-width: 300px;">
          <label for="codigo_documento_gestor">Documento gestor (NIE, NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento_gestor" id="codigo_documento_gestor"
                placeholder="Documento gestor (NIE, NIF)" type="text">
            </mat-form-field>
          </div>
        </div>

        <!--<div class="col-sm flex-grow-2" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')">
          <label for="razon_social">Razón Social </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="razon_social" id="razon_social" placeholder="Razón Social" type="text" maxlength="255">
              <mat-error *ngIf="controlHasError( 'razon_social', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>-->
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 200px; max-width: 300px;">
          <label for="estadoGestor">Estado Gestor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estadoGestor" id="estadoGestor" placeholder="-- Estado Gestor --" multiple>
                <mat-option *ngFor="let des of estadoGestorArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estadoGestor')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estadoGestor')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1" style="flex: 1 1 202px; max-width: 202px;">
          <label for="fecha_desde">Fecha de aceptación desde <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker1" formControlName="fecha_desde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker1"></mat-datepicker-toggle>
              <mat-datepicker #datepicker1>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_desde', 'required')">Campo
                obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('fecha_desde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>

        </div>

        <div class="col-sm flex-grow-1" style="flex: 1 1 180px; max-width: 200px;">
          <label for="fecha_hasta">Fecha de aceptación hasta <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker2" formControlName="fecha_hasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_hasta', 'required')">Campo
                obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('fecha_hasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1" style="flex: 1 1 180px; max-width: 200px;">
          <label for="fecha_desde">Fecha aportación desde</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker3" formControlName="fecha_aport_desde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker3"></mat-datepicker-toggle>
              <mat-datepicker #datepicker3>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_aport_desde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1" style="flex: 1 1 180px; max-width: 200px;">
          <label for="fecha_hasta">Fecha aportación hasta</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker4" formControlName="fecha_aport_hasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker4"></mat-datepicker-toggle>
              <mat-datepicker #datepicker4>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_aport_hasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" style="flex: 1 1 230px; max-width: 300px;">
          <label for="codigoLer">Codigo Ler y Descripción</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="codigoLer" id="codigoLer" placeholder="-- Codigo Ler y Descripción --" multiple>
                <mat-option *ngFor="let des of codigoLerArray" [value]="des">
                  {{ des.tipoCodigo }} - {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('codigoLer')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'codigoLer')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" style="flex: 1 1 230px; max-width: 300px;">
          <label for="operacionGestion">Operación de Gestión y Descripción</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="operacionGestion" id="operacionGestion" placeholder="-- Operación de Gestión y Descripción --" multiple>
                <mat-option *ngFor="let des of operacionGestionArray" [value]="des">
                  {{ des.codigo }} - {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('operacionGestion')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'operacionGestion')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
                <div class="col-sm flex-grow-1" *ngIf="canViewResource('AD-ADHERIDO')" style="flex: 1 1 250px; max-width: 300px;">
          <label for="doc_identificacion">Doc. Identificación/Full Seguiment </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="doc_identificacion" id="doc_identificacion"
                placeholder="Doc. Identificación/Full Seguiment " type="text" maxlength="255">
              <mat-error *ngIf="controlHasError( 'doc_identificacion', 'maxlength')">Máximo 255 caracteres</mat-error>
              <mat-error *ngIf="controlHasError( 'doc_identificacion', 'minlength')">Mínimo 6 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 250px; max-width: 300px;">
          <label for="doc_identificacion">Doc. Identificación/Full Seguiment </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="doc_identificacion" id="doc_identificacion"
                placeholder="Doc. Identificación/Full Seguiment " type="text" maxlength="255">
              <mat-error *ngIf="controlHasError( 'doc_identificacion', 'maxlength')">Máximo 255 caracteres</mat-error>
              <mat-error *ngIf="controlHasError( 'doc_identificacion', 'minlength')">Mínimo 6 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1" *ngIf="canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')" style="flex: 1 1 200px; max-width: 300px;">
          <label for="estado">Estado aportación</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado aportación --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm flex-grow-1" style="flex: 1 1 190px; max-width: 190px;">
          <label for="plataformaOrigen">Plataforma origen </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="plataformaOrigen" id="plataformaOrigen" placeholder="-- Plataforma origen --">
                <mat-option *ngFor="let des of plataformaOrigenArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('plataformaOrigen')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'plataformaOrigen')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('AD-ENV-GEST') ||  this.canViewResource('AD-ENV-CONS') || canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('AD-ENV-GEST') ||  this.canViewResource('AD-ENV-CONS') || canViewResource('SDDR-CC-ENV-GEST')||canViewResource('SDDR-CC-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
<mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table" style="color: #080C35;">{{ recordsTotal }} registros encontrados</span><span *ngIf="totalKilos !== undefined" class="align-middle tit-table" style="margin-left: 1.5rem; color: #080C35;">Total Kg gestionados: <strong>{{ totalKilos | number:'1.2-2' }}</strong></span></div>
        <div class="text-right">
          <div class="d-inline">

            <div class=" d-flex d-inline dropdown show">
              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (actionButton)="action($event)" (sort)="sortGrid($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario</p>
        <p class="mensaje-linea"></p>
      </div>
    </ng-template>
  </div>
